export const NotificationEN = {
    "notification":{
        "sendAll" : "View all",
        "all" : "All",
        "process" : "Procedures",
        "notification" : "Notification",
        "red" : "Read",
        "nored" : "No Read",
        "404" : "Resource not found in system",
        "500" : "There is a problem with the system, please wait a moment before taking action again",
        loginFailed : "Wrong username or password. Please try again!",
        layoutNameFailed : "The layout name and statistics cannot be left blank for what?",
        layoutRequest : "Must submit to layout to display?",
        typeSalaryRequest : "Salary form not entered",
        totalSalaryRequest : "Amount of salary form not entered",
        benefitType : "Type of allowance not entered",
        totalSalaryBenefitRequest : "Amount of allowance not entered",
        supportOnlyJpgPng : "You can only upload JPG/PNG file!",
        totalMaxFileSize : "Total file size is not more than 100mb!",
        uploadMaxSize : "Total image size is not more than 2MB!"
    }
}